<template>

  <!-- Add Media Modal -->
  <div class="modal fade" id="mediaModal">
    <div class="modal-dialog modal-dialog-centered modal-lg custom-modal-two">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4> Select Media </h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">

              <!-- USER TABLE -->
              <filter-table
                  :extra-class="['table', 'datanew']"
                  :columns="media.columns"
                  :data="media.data.value"
                  :filters="media.filters"
              >
                <template #header>
                  <div class="d-flex justify-content-between align-items-center">
                    <h4>Available Media</h4>
                    <div class="d-flex">
                      <div class="me-2" style="cursor: pointer;">
                        <a
                            href="javascript:void(0);"
                            class="btn btn-added"
                            @click="openUploadModal()"
                        >
                          <vue-feather type="plus-circle" class="me-2"></vue-feather>
                          Add New Media
                        </a>
                      </div>
                      <div style="cursor: pointer;">
                        <b-button @click="add">
                          Add
                        </b-button>
                      </div>
                    </div>

                  </div>
                </template>
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'url'">
                    <div class="userimgname gap-2 align-items-center">
                      <a href="javascript:void(0);" class="userslist-img bg-img gap-2">
                        <Avatar
                            :src="record.url"
                            :alt="record.title"
                            :shape="shape"
                            img-class="user-image"
                        />
                      </a>

                    </div>
                  </template>

                  <template v-if="column.key === 'title'">
                    <td class="action-table-data">
                      <p>
                        {{
                          record.title.split(' ').slice(0, 2).join(' ') +
                          (record.title.split(' ').length > 2 ? '...' : '')
                        }}
                      </p>
                    </td>
                  </template>

                  <template v-if="column.key === 'action'">
                    <td class="action-table-data">
                      <div class="edit-delete-action">
                        <input type="checkbox"
                               class="red-check"
                               :checked="selectedItems.some((item) => item.id == record.id)"
                               @change="() => toggleSelection(record)"/>

                      </div>
                    </td>
                  </template>
                </template>

                <!-- </template> -->
              </filter-table>
              <!-- USER TABLE -->

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Media Modal -->

  <MediaModal ref="uploadMediaModal"/>

</template>

<script setup>

import {computed, ref, onMounted} from "vue";
import MediaModal from "@/views/pages/mediaLibrary/modal/media-modal.vue";

import {useMediaStore} from "@/store/mediaStore";
import Avatar from "@/components/avatar.vue";

const mediaStore = useMediaStore();

const props = defineProps({
  selectMultiple: {
    type: Boolean,
    default: false
  },
  selectedMedia: {
    type: Array,
    default: []
  }
});

const emit = defineEmits(['selected']);

const selectedItems = ref([]);
const shape = ref('square');

const media = {
  filters: ["title", "file_type"],
  columns: [
    {
      title: "Medium",
      dataIndex: "url",
      key: "url",
      sorter: {
        compare: (a, b) => {
          a = a.name.toLowerCase();
          b = b.name.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: {
        compare: (a, b) => {
          a = a.title.toLowerCase();
          b = b.title.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "File Type",
      dataIndex: "file_type",
      key: "file_type",
      sorter: {
        compare: (a, b) => {
          a = a.file_type.toLowerCase();
          b = b.file_type.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "Action",
      key: "action",
      sorter: true,
    },
  ],
  data: computed(() => mediaStore.media),
};

function openUploadModal() {

  $("#uploadMediaModal").modal("show");
}

function toggleSelection(record) {
  if (!props.selectMultiple) {
    // Only one at a time
    selectedItems.value = [record];
  } else {
    const exists = selectedItems.value.find((item) => item.id === record.id);
    if (exists) {
      selectedItems.value = selectedItems.value.filter(
          (item) => item.id !== record.id
      );
    } else {
      selectedItems.value.push(record);
    }
  }
}

function setSelectedItems(isMultiple) {

  if (!props.selectedMedia || props.selectedMedia.length === 0) {
    selectedItems.value = [];
    return;
  }

  if (isMultiple) {
    // Multiple selections (curated images)
    selectedItems.value = [...props.selectedMedia];
  } else {
    // Single selection (thumbnail)
    const firstItem = props.selectedMedia[0];
    selectedItems.value = firstItem ? [firstItem] : [];
  }
}

function add() {
  emit("selected", selectedItems.value);
  $("#mediaModal").modal("hide");
}

onMounted(() => {
  const modal = document.getElementById("mediaModal");

  modal.addEventListener("shown.bs.modal", () => {
    setSelectedItems(props.selectMultiple); // Only runs when modal actually opens
  });
});

</script>

<style scoped>

.red-check {
  appearance: none;
  -webkit-appearance: none;
  width: 15px;
  height: 15px;
  border: 2px solid #777;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}

/* Red background when checked */
.red-check:checked {
  background-color: red;
  border-color: red;
}

/* Optional: add a checkmark */
.red-check:checked::after {
  content: "✓";
  color: white;
  font-size: 11px;
  font-weight: bold;
  position: absolute;
  top: -3px;
  left: 3px;
}

</style>